<template>
  <div>
    <main>
      <pcbanner></pcbanner>
      <!-- 服务项目 -->
      <div class="server pad50">
        <div class="w">
          <h3 class="red center f36 pad25 fw" v-html="list.serve.title"></h3>
          <div class="stripred"></div>
          <p class="pad25  center col_6" v-html="list.serve.intro"></p>
          <div class="servers w">
            <div class="servers-main" v-for="item in list.serve.content" :key="item.id">
              <div class="servers-king">
                <router-link to="" tag="a" @click.native="setmenu(item.id)">
                  <div class="servers-top">
                    <img :src="item.img" alt/>
                    <div class="servers-top_p" v-html="item.name"></div>
                    <!-- <p class="col_6" v-html="item.scene"></p>
                    <p class="col_6" v-html="item.nature"></p> -->
                    <p class="col_6" v-for="(items,index)  in item.intro" :key="index" v-html="items"></p>
                  </div>
                  <span class="line  line_top"></span>
                  <span class="line  line_bottom"></span>
                  <span class="line  line_left"></span>
                  <span class="line  line_right"></span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 成功案例 -->
      <div class="success" :style="{backgroundImage:'url('+list.success.background+')'}">
        <div class="w">
          <h3 class="white center f36 fw pad25" v-html="list.success.title"></h3>
          <div class="stripred"></div>
          <p class="pad25  center white" v-html="list.success.intro"></p>
          <div class="successful">
            <div class="successful-main fl" v-for="item in list.success.content" :key="item.id">
              <div class="successful-photo">
                <div class="successful_img" :style="{backgroundImage:'url('+item.img+')'}">
                  <router-link to="" tag="a" @click.native="caseid(item.id)">
                    <img src="../../assets/images/search.png" alt/>
                    <p class="white center">点击查看</p>
                  </router-link>
                </div>

              </div>
              <p class="white center p_top" v-html="item.name"></p>
              <p class="center  white f14 p_bot" v-html="item.scene"></p>
            </div>
          </div>
          <div class="success-more">
            <router-link class="white center more" to="" tag="a" @click.native="webcase">了解更多</router-link>
          </div>
        </div>
      </div>
      <!-- 关于我们 -->
      <div class="about pad50">
        <div class="w clearfix">
          <h3 class="red center f36 fw pad25" v-html="list.about.title"></h3>
          <div class="stripred"></div>
          <p class="pad25  center col_6" v-html="list.about.intro"></p>

          <p :class="{'pad10 center':true,' ':index == 0,' f18 red':index == 3}"
             v-for="(item,index) in list.about.intros" :key="index" v-html="item"></p>

          <div class="cp_t white f18">
            <!-- < 我产品是这样出来的 > -->
            <img :src="list.about.cp_img"/>
          </div>
          <div class="abouts">
            <div class="abouts-main fl" v-for="item in list.about.content" :key="item.id">
              <div class="img_div">
                <img :src="item.img"/>
              </div>
              <p class="center pad25 f18" v-html="item.name" :style="{'color':item.color}"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- 专注于软件研发 -->
      <img :src="list.focus" class="focus"/>
      <!-- 飞天动态 -->
      <div class="dynamic">
        <div class="w clearfix  dynamic_contents">
          <div class="dynamic-main fl dynamic-state" :style="{backgroundImage:'url('+list.dynamic.background+')'}">
            <div class="mr_50">
              <h3 class="red center f36 fw pad25" v-html="list.dynamic.title" @click="dynamicMain"></h3>
              <div class="stripred"></div>
              <p class="pad10  center col_6 pt13" v-html="list.dynamic.intro"></p>
            </div>
          </div>

          <div class="dynamic-right fr">
            <ul>
              <li v-for="(item,index) in list.dynamic.content.viewpoint.content" v-if="index<4" :key="item.id"
                  class="col_a9">
                <router-link to="" tag="a" @click.native="gonews(item.id)">
                  <div class="time fl">
                    <p class="big_time">
                      {{item.month}} | {{item.day}}
<!--                      {{item.time_top}}-->
                    </p>
<!--                    <p class="small_time">-->
<!--                      {{item.time_bottom}}-->
<!--                    </p>-->
                  </div>
                  <div class="fl dynamic_list_r ">
                    <div class="dynamic_list_top   f16" v-html="item.title"></div>
                    <p class="gray dynamic_list_bottom" v-html="item.intro"></p>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 合作用户 -->
      <div class="cooperation pad50">
        <div class="w">
          <h3 class="red center f36 fw pad25" v-html="list.cooperation.title"></h3>
          <div class="stripred"></div>
          <p class="pad25  center col_6 pb15" v-html="list.cooperation.intro"></p>
          <div class="cooperations">
            <div class="cooperations-main fl" v-for="item in list.cooperation.content" :key="item.id">
              <img :src="item.img"/>
            </div>
          </div>
          <div class="cooperations-more">
            <router-link class="white center more" to="" tag="a" @click.native="webcase">了解更多</router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        time: [],
        list: {
          serve: {
            title: "我们的服务",
            intro: "服务成就品牌，品牌体现技能，技能展现实力，实力彰显价值",
            content: [
              {
                id: 3,
                img: require("@/assets/images/website.jpg"),
                name: "网站建设",
                scene: "针对性网站优化",
                nature: "网站建设",
                intro: [
                  "域名、空间、国外空间",
                  "网站建设/网页设计",
                  "一站式网站运营"
                ]
              },
              {
                id: 4,
                img: require("@/assets/images/weixinlogo.jpg"),
                name: "微信营销",
                scene: "微信应用开发",
                nature: "网络运营",
                intro: [
                  "微信平台搭建",
                  "微官网制作 ",
                  "微信活动定制",
                ]
              },
              {
                id: 5,
                img: require("@/assets/images/APP.jpg"),
                name: "软件开发",
                scene: "IOS、Android",
                nature: "研究开发",
                intro: [
                  "智慧系统定制",
                  "微信小程序定制",
                  "微信企业号开发",
                ]
              },
              {
                id: 6,
                img: require("@/assets/images/brand.jpg"),
                name: "品牌设计",
                scene: "根据客户所在行业",
                nature: "设计品牌",
                intro: [
                  "vi、logo设计",
                  "画册、折页设计",
                  "视频宣传片制作",
                ]
              },
            ]
          },
          success: {
            title: "",
            intro: "",
            background: '',
            content: []
          },
          about: {
            title: "飞天科技",
            intro: "科技·创造·想象的理念，努力为树立行业旗帜而奋斗",
            intros: [
              "石家庄飞天科技开发有限公司致力于网站建设、微信营销、软件开发、品牌设计等服务。",
              " “科技 · 创造 · 想象”，我们用先进的理念、专业的技术、优质的产品、贴心的服务为您创造价值，努力为树立行业旗帜而奋斗！",
            ],
            cp_img: require("@/assets/images/cp_img.png"),
            content: [
              {
                id: 1,
                img: require("@/assets/images/lc_1.png"),
                name: "需求沟通",
                color: "#1dbfbf"
              },
              {
                id: 2,
                img: require("@/assets/images/lc_2.png"),
                name: "创意设计",
                color: "#ffba59"
              },
              {
                id: 3,
                img: require("@/assets/images/lc_3.png"),
                name: "前端制作",
                color: "#30a2f2"
              },
              {
                id: 4,
                img: require("@/assets/images/lc_4.png"),
                name: "技术开发",
                color: "#ea68a2"
              },
              {
                id: 5,
                img: require("@/assets/images/lc_5.png"),
                name: "测试调试",
                color: "#3981e5"
              },
              {
                id: 6,
                img: require("@/assets/images/lc_6.png"),
                name: "上线运行",
                color: "#ec6b71"
              }
            ]
          },
          focus: require("@/assets/images/tu.png"),
          dynamic: {
            title: "",
            intro: "",
            background: '',
            content: {
              viewpoint: {
                title: "",
                site: "",
                content: []
              },
              extend: {
                title: "",
                site: "",
                content: []
              }
            }
          },
          cooperation: {
            title: "我们的客户",
            intro: "提升品牌我们一直在努力，感谢您对我们的信任",
            site: "/",
            content: [
              {id: 20, img: require("@/assets/images/cooperation/20.png")},//1
              {id: 2, img: require("@/assets/images/cooperation/2.png")}, //2
              {id: 5, img: require("@/assets/images/cooperation/5.png")}, //3
              {id: 7, img: require("@/assets/images/cooperation/7.png")}, //4
              {id: 11, img: require("@/assets/images/cooperation/11.png")}, //5
              {id: 21, img: require("@/assets/images/cooperation/21.png")},//6
              {id: 23, img: require("@/assets/images/cooperation/23.png")},//7
              {id: 24, img: require("@/assets/images/cooperation/24.png")},//8
              {id: 3, img: require("@/assets/images/cooperation/3.png")},  //9
              {id: 1, img: require("@/assets/images/cooperation/01.png")}, //10
              {id: 4, img: require("@/assets/images/cooperation/4.png")}, //11
              {id: 19, img: require("@/assets/images/cooperation/19.png")},//12
              {id: 6, img: require("@/assets/images/cooperation/6.png")},
              {id: 12, img: require("@/assets/images/cooperation/12.png")},
              {id: 22, img: require("@/assets/images/cooperation/22.png")},

              {id: 8, img: require("@/assets/images/cooperation/8.png")},
              {id: 9, img: require("@/assets/images/cooperation/9.png")},
              {id: 10, img: require("@/assets/images/cooperation/10.png")},

              // {id: 13, img: require("@/assets/images/cooperation/13.png")},
              // {id: 14, img: require("@/assets/images/cooperation/14.png")},
              // {id: 15, img: require("@/assets/images/cooperation/15.png")},
              // {id: 16, img: require("@/assets/images/cooperation/16.png")},
              // {id: 17, img: require("@/assets/images/cooperation/17.png")},
              // {id: 18, img: require("@/assets/images/cooperation/18.png")},
            ]
          }
        }
      };
    },
    methods: {

      //新闻列表页跳转
      dynamicMain() {
        this.$router.push('/itemnews.html')
      },
      async getlist() {
        var dt = await this.$axios.get('/api/index')
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          console.log(data);
          return;
        }
        // console.log(dt)
        this.list.success = dt.data.data.success
        dt.data.data.dynamic.content.viewpoint.content.map(item => {
          var a = item.create_time.split("-")
          item.time_top = a[2]
          item.time_bottom = a[0] + "-" + a[1]
        })
        this.list.dynamic = dt.data.data.dynamic
      },
      //我们的服务子栏目跳转
      setmenu(val) {
        this.$router.push({
          name: 'items', params: {
            id: val + '.html'
          }
        })
      },
      //新闻详情页
      gonews(val) {
        this.$router.push({
          name: 'news', params: {
            id: val + '.html',
          }
        })
      },
      webcase() {
        this.$router.push({
          name: 'webcase', params: {
            id: 101 + '.html'
          }
        })
      },
      caseid(val) {
        this.$router.push({
          name: 'details', params: {
            id: val + '.html',
            casemenu: 2
          }
        })
      },
    },
    created() {
      this.getlist()
    },

    props:[
      'nav_id'
    ]
  };
</script>
<style scoped lang="less">
  main {
    background: #fff;
  }

  /* // 我们的服务 */

  .servers {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
    padding-top: 20px;

    .servers-main {
      box-sizing: border-box;
      min-width: 240px;

      .servers-king {

        min-height: 250px;
        position: relative;
        border: 1px solid #ccc;
        border-bottom: 3px solid #e50012;

      }

      .servers-bot {
        transition: all 0.5s ease 0s;
        width: 100%;
        height: 100%;
        position: absolute;
        background: black;
        opacity: 0;

        p {
          font-size: 8px;
          text-align: center;
          color: #bbb;
          margin-top: 30px;
        }
      }

      .servers-top {
        margin: 40px;

        img {
          height: 120px;
          margin: 0 auto;
          display: inherit;
          transition: all 0.5s;

        }

        .servers-top_p {
          color: #e50012;
          text-align: center;
          font-size: 16px;
          margin: 30px 0 15px;
          font-weight: 600;
        }

        p {
          text-align: center;
          margin-top: 8px;
          font-size: 14px;
        }
      }
    }

    .servers-main:hover .servers-bot {
      opacity: 0.8;
    }


    .servers-main:hover {
      .servers-king {
        border-bottom: 3px solid #fff;
      }

      img {
        transform: scale(1.1);
      }
    }
  }


  .line {
    display: inline-block;
    background-color: red;
    position: absolute;
    -webkit-transition: 0.5s ease;
    -o-transition: 0.5s ease;
    transition: 0.5s ease;

  }

  .servers-king .line_top {
    height: 2px;
    width: 0;
    left: 0;
    top: -2px;
  }

  .servers-king:hover .line_top {
    width: 100%;
    left: 0px;
  }

  .servers-king .line_right {
    height: 0;
    width: 2px;
    top: 0;
    right: -2px;
  }

  .servers-king:hover .line_right {
    height: 100%;
    top: 0px;
  }

  .servers-king .line_bottom {
    width: 2px;
    height: 0;
    bottom: 0;
    left: -2px;
  }

  .servers-king:hover .line_bottom {
    height: 100%;
    bottom: 0px;
  }

  .servers-king .line_left {
    height: 2px;
    width: 0;
    right: 0;
    bottom: -2px;
  }

  .servers-king:hover .line_left {
    width: 100%;
    right: 0;
  }


  /* 成功案例 */
  .success {
    background-size: 100% 100%;
    padding: 50px 0 50px;

    .successful {
      padding-bottom: 20px;
      padding-top: 5px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      overflow: hidden;

      .successful-main {
        box-sizing: border-box;
        padding-bottom: 20px;

        .p_top {
          padding: 15px 0 8px;
          width: 272px;
        }

        .p_bot {
          width: 272px;
        }

        .successful-photo {
          background-size: 100% 120%;
          border: 10px solid white;
          box-sizing: border-box;
          height: 190px;
          overflow: hidden;

          .successful_img {
            background-position: top center;
            background-size: 100%;
            background-repeat: no-repeat;
            transition: all 0.5s;
            width: 100%;
            height: 100%;

          }

          a {
            border-radius: 5px;
            transition: all 0.5s ease 0s;
            display: inline-block;
            width: 250px;
            height: 100%;
            background: black;
            opacity: 0;
            box-sizing: border-box;
          }

          img {
            width: 60px;
            margin: 0 auto;
            display: block;
            padding-top: 50px;
          }

          p {
            padding-top: 10px;
            padding-bottom: 20px;
            font-size: 14px;
          }
        }

        .successful-photo:hover {
          .successful_img {
            transform: scale(1.1);
          }

          a {
            opacity: 0.6;
          }

        }
      }
    }

    .success-more {
      text-align: center;
      padding-bottom: 30px;
    }
  }

  .cp_t {
    text-align: center;
    height: 35px;
    margin: 40px 0;

    img {
      margin: 0 auto;
    }

  }

  /* 关于我们 */
  .abouts {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-around;
    background: url(../../assets/images/about_bg.png) no-repeat;
    background-position: 0px 50px;


    .abouts-main {
      text-align: center;
      color: #1dbfbf;
    }

    img {
      transition: all 0.5s;
    }

    .abouts-main:hover {
      .img_div {
        border: 4px solid red;
        box-shadow: 0 8px 30px 0 #ccc;

        img {
          transform: scale(1.1);
          opacity: .8;
        }
      }
    }

    .img_div {
      border-radius: 100%;
      border: 4px solid transparent;
      transition: all 0.5s ease 0s;
      transform: scale(0.9);
    }


  }

  /* 专注于软甲研发和设计 */
  .focus {
    width: 100%;
  }

  /* 飞天动态 */
  .dynamic {
    padding: 80px 0;

    .dynamic_contents {
      /* display: flex;
      align-items: center;
      justify-content: space-between; */
    }

    .dynamic-right {
      background: #f2f2f2;
      width: 60%;
      margin-top: 18px;
      margin-right: 10px;

      ul {
        padding: 28px 0;

        li {
          font-size: 14px;
          overflow: hidden;
          margin: 0 30px;
          border-bottom: 1px dashed #e5e5e5;

          a {
            display: flex;
            align-items: center;
          }

          .time {
            background: rgba(204, 204, 204, 0.2);
            //width: 75px;
            padding: 10px 4px;
            text-align: center;
            color: #626971;
            margin: 15px;

            .big_time {
              font-weight: bold;
              font-size: 20px;
            }
          }


          .dynamic_list_r {
            padding: 10px 10px 10px 15px;
            max-width: 80%;

            .dynamic_list_top {
              margin-bottom: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .dynamic_list_bottom {
              line-height: 25px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
          }

        }
      }

      ul li:hover {
        .dynamic_list_top {
          color: #e50012;
        }
      }

    }


    .dynamic-main {
      width: 33.33%;
      padding: 0 30px;
      box-sizing: border-box;
      border: 20px solid white;
      font-size: 14px;
      min-height: 495px;

      li {
        list-style: disc;
        margin-left: 15px;
        margin-top: 20px;
      }

      .mr_50 {
        margin-right: 50px;
      }

      .pt13 {
        padding-top: 13px;
      }

      .dynamic-state {
        padding-bottom: 330px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-right: 7%;

        h3 {
          padding-bottom: 10px;
        }


      }
    }

    .dynamic-view {
      padding: 30px 20px;
      background: #eee;

      ul li:hover {
        a {
          color: #e50012;
        }
      }
    }
  }

  /* 合作用户 */
  .cooperation {
    background: #eee;

    .pb15 {
      padding-bottom: 15px;
    }

    .cooperations {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cooperations-main {
        box-sizing: border-box;
        padding: 10px;

        img {
          width: 170px;
        }

        /* img:hover {
          opacity: .7;
        } */
      }

    }

    .cooperations-more {
      text-align: center;
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/index.vue